import React from 'react';
import type { CustomIconComponentProps } from '@ant-design/icons/lib/components/Icon';
const CMP = (props: Partial<CustomIconComponentProps>) => (
  <svg viewBox="0 0 18 18" width={18} height={18}>
    <g id="组件_1_8" data-name="组件 1 – 8" opacity="0.65">
      <rect id="矩形_17" data-name="矩形 17" width="18" height="18" fill="none" />
      <g id="仪表盘" transform="translate(0 1.012)" fill="currentColor">
        <path
          id="路径_28"
          data-name="路径 28"
          d="M81.293,117.463A8.99,8.99,0,1,0,67.212,127.8l.034.028a.654.654,0,0,0,.414.15H78.342a.654.654,0,0,0,.414-.15l.034-.028a8.92,8.92,0,0,0,2.5-10.334Zm-3.283,8.994H67.99a7.473,7.473,0,1,1,10.021,0Z"
          transform="translate(-64 -112)"
        />
        <path
          id="路径_29"
          data-name="路径 29"
          d="M183.03,227.944a.162.162,0,0,0-.227,0l-1.7,1.687a1.127,1.127,0,0,0-1.087.29,1.113,1.113,0,0,0,0,1.582,1.129,1.129,0,0,0,1.591,0,1.111,1.111,0,0,0,.291-1.08l1.7-1.687a.16.16,0,0,0,0-.226l-.569-.565Zm-2.682-2.027h.884a.161.161,0,0,0,.161-.16v-1.6a.161.161,0,0,0-.161-.16h-.884a.161.161,0,0,0-.161.16v1.6A.161.161,0,0,0,180.348,225.917Zm5.223,4.353v.879a.161.161,0,0,0,.161.16h1.607a.161.161,0,0,0,.161-.16v-.879a.161.161,0,0,0-.161-.16h-1.607A.161.161,0,0,0,185.571,230.27Zm.255-3.938-.625-.621a.162.162,0,0,0-.227,0l-1.137,1.13a.16.16,0,0,0,0,.226l.625.621a.162.162,0,0,0,.227,0l1.137-1.13A.16.16,0,0,0,185.827,226.332Zm-9.213-.621a.162.162,0,0,0-.227,0l-.625.621a.16.16,0,0,0,0,.226l1.137,1.13a.162.162,0,0,0,.227,0l.625-.621a.16.16,0,0,0,0-.226Zm-.846,4.4h-1.607a.161.161,0,0,0-.161.16v.879a.161.161,0,0,0,.161.16h1.607a.161.161,0,0,0,.161-.16v-.879A.161.161,0,0,0,175.768,230.11Z"
          transform="translate(-171.79 -221.764)"
        />
      </g>
    </g>
  </svg>
);

export default CMP;
